const updatePaginationCount = (node, resp) => {
  // Get new pagination count markup
  const newPaginationCountHtml = new DOMParser()
    .parseFromString(resp, 'text/html')
    .querySelector('[data-pagination-count]').innerHTML;

  // Render pagination count markup
  const newPaginationCountElem = node.querySelector('[data-pagination-count]');
  newPaginationCountElem.innerHTML = newPaginationCountHtml;
};

export default updatePaginationCount;
